export var DEFAULT_STORE_KEY = "hg-adapt-sdk-store";
export var DEFAULT_STORE_TYPE = "sessionStorage";
